import { Button, Card } from '@repo/shadcn';
import { Link } from 'react-router-dom';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { Route } from '@/constants';

import { PrePurchaseListFilters } from './pre-purchase-list-filters.component';
import { prePurchaseListColumns } from './pre-purchase-list.column';
import { usePrePurchaseList } from './pre-purchase-list.hook';

export const PrePurchaseList = () => {
    const { data, isError, isLoading, isFetching, error } =
        usePrePurchaseList();

    return (
        <SectionContainer
            isLoading={isLoading}
            isError={isError}
            error={error}
            fallbackPath={Route.DASHBOARD}
        >
            <Card className={'space-y-4 p-4'}>
                <div className={'flex justify-between'}>
                    <div className={'space-y-2'}>
                        <HeaderBreadcrumb
                            items={[{ label: 'Pre Purchases' }]}
                        />
                        <SectionTitle>Pre Purchases</SectionTitle>
                    </div>

                    <Link to={Route.PRE_PURCHASE_CREATE}>
                        <Button>New Pre-Purchase</Button>
                    </Link>
                </div>

                <PrePurchaseListFilters />
                <SectionDataTable
                    columns={prePurchaseListColumns}
                    data={data}
                    isLoading={isLoading || isFetching}
                />
            </Card>
        </SectionContainer>
    );
};

PrePurchaseList.displayName = 'PrePurchaseList';
